import React from 'react';
import { Trans } from '@lingui/react/macro';

import CalloutBadge from '@rover/components/src/callouts/CalloutBadge';
import Card from '@rover/components/src/cards/Card';
import TrainingPilot from '@rover/icons/svg/training-pilot.svg';
import { Box, Button, Flex, Heading, Text } from '@rover/kibble/core';
import TrainingUrls from '@rover/react-lib/src/pages/training/constants/urls';
import useInTrainingPilot from '@rover/react-lib/src/pages/training/hooks/useInTrainingPilot';

import emitMetricOnCtaClick from '../emitMetricOnCtaClick';

const DogTrainingPilotCard: React.FC = () => {
  const { shouldShowTrainingEntrypoints } = useInTrainingPilot();
  const url = TrainingUrls.SEARCH;

  return (
    <Card display={['none', 'block']}>
      <Flex alignItems="center">
        <TrainingPilot />
        <Flex mx="4x" flexDirection="column">
          <Heading webProps={{ as: 'div', display: 'flex' }} m="0x" size="200">
            <Trans>Dog Training</Trans>
            {shouldShowTrainingEntrypoints && (
              <Box ml="2x">
                <CalloutBadge value="NEW" />
              </Box>
            )}
          </Heading>
          <Text textColor="tertiary">
            {/* DEV-104195 TODO: translate */}
            With a private trainer
          </Text>
        </Flex>
        <Flex justifyContent="end" flexShrink="0" flexGrow="1">
          <Box
            onPress={() => {
              emitMetricOnCtaClick('training-homepage-cta-click');
            }}
          >
            <Button href={url}>Find a trainer</Button>
          </Box>
        </Flex>
      </Flex>
    </Card>
  );
};

export default DogTrainingPilotCard;
